/**
 * Vehicle engine cylinders layout values
 */
export enum VehicleEngineCylindersLayoutEnum {
	BOXER = 'boxer',
	INLINE = 'inline',
	ROTARY = 'rotary',
	V = 'v',
	VR = 'vr',
	W = 'w',
}
